// extracted by mini-css-extract-plugin
export default {"Inspector":"Inspector_Inspector__GW5VZ"};